module.exports = __webpack_public_path__ + "static/img_20220307.a37257f5.png";